import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
//import cartSliceReducer from "./slices/cartSlice";
import authSlice from "./slices/authSlice";
import foodListSlice from "./slices/foodListSlice";
// import userSlice from "./slices/userSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    // cart: cartSliceReducer,
    auth: authSlice,
    foodList: foodListSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
